/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService, JsonApiResource} from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';
import {ContactDtoModel, ContactListVO, ContactMetaModel} from '@well/domain';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ContactResourceService extends AbstractResourceService<ContactListVO, ContactDtoModel, null, null> {

  constructor(protected httpClient: HttpClient, private environmentService: EnvironmentService) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('companyContactUrl')}`,
      ContactListVO,
      ContactDtoModel
    );
  }

  saveForCurrent(contact: ContactDtoModel): Observable<JsonApiResource<ContactDtoModel, any>>{
    return this.httpClient.post(`${this.url}/current`, contact).pipe(this.getDtoMapper());
  }

  saveForPartner(contact: ContactDtoModel): Observable<JsonApiResource<ContactDtoModel, any>>{
    return this.httpClient.post(`${this.url}/partner`, contact).pipe(this.getDtoMapper());
  }
  updateForPartner(contact: ContactDtoModel): Observable<JsonApiResource<ContactDtoModel, any>>{
    return this.httpClient.put(`${this.url}`, contact).pipe(this.getDtoMapper());
  }

  getTemplateForCurrent(): Observable<JsonApiResource<ContactDtoModel, ContactMetaModel>> {
    return this.httpClient
      .get(`${this.url}/new/template/current`)
      .pipe(this.getDtoMapper());
  }

  getTemplateForPartner(partnerBusinessProfileUuid: string): Observable<JsonApiResource<ContactDtoModel, ContactMetaModel>> {
    return this.httpClient
      .get(`${this.url}/new/template/partner/${partnerBusinessProfileUuid}`)
      .pipe(this.getDtoMapper());
  }

  unsubscribeEmailableContactsByEmail(email: string){
    return this.httpClient.post(`${this.url}/email-unsubscribe/${email}`, {});
  }
}
